import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { message } from 'antd';
import { authActionTypes as actions, authApplications } from '~client/constants/actionTypes';
import {
  updateCommunicationStatus,
  handleFetchCatch,
  fetch,
  isNetworkIssue,
} from '~actions/shared';
import { communicationStatus } from '~client/constants';
import i18n from '~settings/i18n';
import endpoints from '~client/settings/endpoints';
import * as queries from '~settings/queries';

export const initialize = application => ({
  type: actions.INITIALIZE,
  application,
});

export const loggedIn = (email, token) => ({
  type: actions.LOGGED_IN,
  email,
  token,
});

export const login =
  ({ email, password }) =>
  dispatch => {
    dispatch(
      updateCommunicationStatus({
        actionType: actions.LOGIN_IN_CS,
        status: communicationStatus.FETCHING,
      }),
    );

    axios({
      method: 'post',
      url: endpoints.login.url(),
      data: queries.login({ email, password }),
    })
      .then(response => {
        if (response.data.data && response.data.errors) {
          dispatch(
            updateCommunicationStatus({
              actionType: actions.LOGIN_IN_CS,
              status: communicationStatus.ERROR,
              error: response.data.errors,
            }),
          );
        } else if (typeof response.data.errors === 'undefined' && response.data.data) {
          const { authToken } = response.data.data.landlordAccountLogin;
          const { roles } = jwtDecode(authToken);
          if (typeof roles === 'object' && roles.includes('landlord')) {
            dispatch(loggedIn(email, authToken));
            dispatch(
              updateCommunicationStatus({
                actionType: actions.LOGIN_IN_CS,
                status: communicationStatus.IDLE,
              }),
            );
          } else {
            dispatch(
              updateCommunicationStatus({
                actionType: actions.LOGIN_IN_CS,
                status: communicationStatus.ERROR,
                error: response.data.errors,
              }),
            );
          }
        } else {
          dispatch(
            updateCommunicationStatus({
              actionType: actions.LOGIN_IN_CS,
              status: communicationStatus.ERROR,
              error: response.data.errors,
            }),
          );
        }
      })
      .catch(error => {
        if (isNetworkIssue(error)) {
          message.error(i18n.t('landlord.auth.login.alert.timeout'));
        } else {
          message.error(i18n.t('landlord.auth.login.alert.clienterror'));
        }
        handleFetchCatch({
          actionType: actions.LOGIN_IN_CS,
          dispatch,
          error,
        });
      });
  };

export const logout = () => ({
  type: actions.LOGOUT,
});

export const emailResetSuccessful = () => ({
  type: actions.EMAIL_RESET_SUCCESSFUL,
});

export const resetPassword = email => dispatch => {
  dispatch(
    updateCommunicationStatus({
      actionType: actions.UPDATE_COMMUNICATION_STATUS,
      application: authApplications.RESET_PASSWORD,
      status: communicationStatus.FETCHING,
    }),
  );

  axios({
    method: 'post',
    url: endpoints.resetPassword.url(),
    data: queries.resetPassword({
      email,
      portal: 'LANDLORD',
    }),
  })
    .then(response => {
      if (typeof response.data.error === 'undefined') {
        dispatch(emailResetSuccessful());
      } else {
        dispatch(
          updateCommunicationStatus({
            actionType: actions.UPDATE_COMMUNICATION_STATUS,
            application: authApplications.RESET_PASSWORD,
            status: communicationStatus.ERROR,
            error: response.data,
          }),
        );
      }
    })
    .catch(error => {
      if (isNetworkIssue(error)) {
        message.error(i18n.t('landlord.auth.login.alert.timeout'));
      } else {
        message.error(i18n.t('landlord.auth.login.alert.clienterror'));
      }
      handleFetchCatch({
        actionType: actions.UPDATE_COMMUNICATION_STATUS,
        application: authApplications.RESET_PASSWORD,
        dispatch,
        error,
      });
    });
};

export const setPassword =
  ({ token, newPassword, portal }) =>
  dispatch => {
    dispatch(
      updateCommunicationStatus({
        actionType: actions.UPDATE_COMMUNICATION_STATUS,
        application: authApplications.SET_PASSWORD,
        status: communicationStatus.FETCHING,
      }),
    );

    axios({
      method: 'post',
      url: endpoints.setPassword.url(),
      data: queries.setPassword({
        token,
        newPassword,
        portal,
      }),
    })
      .then(response => {
        if (
          response.data &&
          response.data.data &&
          response.data.data.resetPassword &&
          response.data.data.resetPassword.success
        ) {
          window.location.href = `${process.env.PUBLIC_URL}/login`;
        } else {
          dispatch(
            updateCommunicationStatus({
              actionType: actions.UPDATE_COMMUNICATION_STATUS,
              application: authApplications.SET_PASSWORD,
              status: communicationStatus.ERROR,
              error: response.data,
            }),
          );
        }
      })
      .catch(error => {
        if (isNetworkIssue(error)) {
          message.error(i18n.t('landlord.auth.login.alert.timeout'));
        } else {
          message.error(i18n.t('landlord.auth.login.alert.clienterror'));
        }
        handleFetchCatch({
          actionType: actions.UPDATE_COMMUNICATION_STATUS,
          application: authApplications.SET_PASSWORD,
          dispatch,
          error,
        });
      });
  };

export const setContacts = userClientInfo => ({
  type: actions.SET_CONTACTS,
  userClientInfo,
});

export const getUserClientInfo = () => dispatch => {
  axios.get(endpoints.clientInfo.url()).then(response => {
    dispatch(setContacts(response.data));
  });
};

export const setLandlordType = payload => ({
  type: actions.SET_LANDLORD_TYPE,
  payload,
});

export const getLandlordType = () => dispatch => {
  fetch({
    endpoint: endpoints.graphql.url(),
    communicationType: actions.GET_LANDLORD_TYPE_CS,
    params: queries.getLandlordType(),
    dispatch,
    successAction: setLandlordType,
  });

  return true;
};

export const setLandlordProperties = payload => ({
  type: actions.SET_LANDLORD_PROPERTIES,
  payload,
});

export const setLandlordName = payload => ({
  type: actions.SET_LANDLORD_NAME,
  payload,
});
